export var DEFAULT_FORM_STATE = {
    visible: true,
    loading: false,
    disableValidate: false,
    description: '',
    disabled: false,
    label: '',
    tooltip: '',
    placeholder: '',
    initialized: false,
    validating: false,
    modified: false,
    required: undefined,
    validateFirst: false,
    rules: undefined,
    error: undefined,
    initialValue: undefined,
};
// export const RESET_FORM_STATE: IFormState<any> = {
//   visible: DEFAULT_FORM_STATE.visible,
//   loading: DEFAULT_FORM_STATE.loading,
//   rules: DEFAULT_FORM_STATE.rules,
//   error: DEFAULT_FORM_STATE.error,
//   disableValidate: DEFAULT_FORM_STATE.disableValidate,
//   visible: DEFAULT_FORM_STATE.visible,
// }
/**
 * 内部调用 log，一般不对外展示的 log 使用
 */
export var INTERNAL_LOG = '$$_INTERNAL_LOG_$$';
export var ROOT_VALUE_PATH = '$$_ROOT_$$';
